module.exports = __webpack_public_path__ + "img/values-bg.16c2cd70.svg";